import React, {useState} from 'react';
import {Snackbar} from '@mui/material';

export default function ShareButton() {
    const [message, setMessage] = useState(null);

    const onClose = () => {
        setMessage(null);
    };

    return (
        <>
            <Snackbar
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                open={message !== null}
                onClose={onClose}
                message={message}
            />
        </>
    );
}
